import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import { collection, doc, getDoc, getDocs, orderBy, query } from "firebase/firestore";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { auth, db } from "../Config/firebase";
import {
  COLLECTION_DENSIDADE_IN_SITU,
  calcularEnsaioInSitu,
  criarEnsaiosInSitu,
  estadoInicialDensidadeInSitu,
  recalcularDensidadeInSitu,
} from "./densidadeInSituModel";
import { COLLECTION_COMPACTACAO } from "../CadastroCompactacao/compactacaoModel";
import RelatorioDensidadeInSituPrint from "./RelatorioDensidadeInSituPrint";
import { consultaTenantAtual, getUsuarioAtualComTenant } from "../Utils/tenant";
import {
  podeEditarCadastroDireto,
  solicitarAprovacaoCadastro,
} from "../Utils/aprovacaoCadastro";
import {
  atualizarDocumentoComMesclagem,
  extrairCamposAlterados,
} from "../Utils/concorrenciaFirestore";

const cellSx = {
  textAlign: "center",
  verticalAlign: "middle",
  px: "6px",
  py: "5px",
  fontSize: 12,
  color: "#334155",
  borderColor: "#d7dde8",
};

const campoCompactoSx = {
  "& .MuiInputBase-root": {
    minHeight: 38,
  },
  "& .MuiInputBase-input": {
    py: "8px",
    fontSize: 14,
  },
};

const camposIdentificacao = [
  ["numero", "Ensaio", ""],
  ["localizacao", "Localização", ""],
  ["hora", "Hora", ""],
  ["camadaCota", "Camada/Cota", ""],
  ["profundidade", "Profundidade", ""],
];

const camposDensidade = [
  ["frascoAreia", "Frasco de areia", ""],
  ["pesoInicialFrasco", "A - Peso inicial do frasco", ""],
  ["pesoFinalFrasco", "B - Peso final do frasco", ""],
  ["pesoDeslocado", "C - Peso deslocado", "C = A - B"],
  ["pesoAreiaFunil", "D - Peso da areia no funil", ""],
  ["pesoAreiaFuro", "E - Peso da areia no furo", "E = C - D"],
  ["densidadeAreia", "F - Densidade da areia", ""],
  ["volumeFuro", "G - Volume do furo", "G = E / F"],
  ["pesoSoloTara", "H - Peso do solo + tara", ""],
  ["pesoTara", "I - Peso da tara", ""],
  ["pesoSoloUmido", "J - Peso do solo úmido", "J = H - I"],
  ["umidadeSolo", "K - Umidade do solo", ""],
  ["pesoSoloSeco", "L - Peso do solo seco", "L = J / (100 + K) * 100"],
  ["densidadeSoloSeco", "M - Dens. do solo seco", "M = L / G"],
];

const camposCompactacao = [
  ["densidadeMaxima", "N - Densidade máxima", "Cadastro de compactação"],
  ["umidadeOtima", "O - Umidade ótima", "Cadastro de compactação"],
  ["grauCompactacao", "P - Grau de compactação", "P = (M / N) * 100"],
];

const camposCalculados = new Set([
  "pesoDeslocado",
  "pesoAreiaFuro",
  "volumeFuro",
  "pesoSoloUmido",
  "pesoSoloSeco",
  "densidadeSoloSeco",
  "grauCompactacao",
]);
const camposSomenteCompactacao = new Set(["densidadeMaxima", "umidadeOtima"]);
const camposIdentificacaoSet = new Set(camposIdentificacao.map(([campo]) => campo));
const COMPACTACAO_MANUAL_ID = "__manual__";

function temValorPreenchido(valor) {
  return valor !== null && valor !== undefined && String(valor).trim() !== "";
}

function condicaoHabilitada(ensaio = {}) {
  return temValorPreenchido(ensaio.grauCompactacao) && temValorPreenchido(ensaio.umidadeSolo);
}

function campoTabela(valor, onCommit, readOnly = false, enter = {}) {
  if (readOnly) {
    return (
      <Box sx={{ minHeight: 24, display: "grid", placeItems: "center", fontSize: 12, color: "#0f172a", lineHeight: 1.1 }}>
        {valor || "-"}
      </Box>
    );
  }

  return (
    <TextField
      key={valor ?? ""}
      defaultValue={valor ?? ""}
      onBlur={(event) => onCommit(event.target.value)}
      variant="outlined"
      size="small"
      fullWidth
      inputProps={{
        autoComplete: "off",
        "data-densidade-row": enter.row,
        "data-densidade-col": enter.col,
        onKeyDown: (event) => {
          if (event.key !== "Enter") return;

          event.preventDefault();
          event.stopPropagation();

          onCommit(event.currentTarget.value);

          const row = Number(event.currentTarget.dataset.densidadeRow);
          const col = event.currentTarget.dataset.densidadeCol;

          if (!Number.isFinite(row) || col === undefined) return;

          const inputsDaColuna = Array.from(
            document.querySelectorAll(`input[data-densidade-col="${col}"]`)
          ).sort((a, b) => Number(a.dataset.densidadeRow) - Number(b.dataset.densidadeRow));

          const proximoNaColuna = inputsDaColuna.find(
            (input) => Number(input.dataset.densidadeRow) > row
          );

          if (proximoNaColuna) {
            proximoNaColuna.focus();
            proximoNaColuna.select?.();
            return;
          }

          const proximaColuna = String(Number(col) + 1);
          const primeiroDaProximaColuna = document.querySelector(
            `input[data-densidade-col="${proximaColuna}"]`
          );

          if (primeiroDaProximaColuna) {
            primeiroDaProximaColuna.focus();
            primeiroDaProximaColuna.select?.();
          }
        },
        style: { textAlign: "center", fontSize: 12, padding: "5px 4px", height: 18 },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: 30,
          backgroundColor: "#fff",
          borderRadius: "4px",
        },
      }}
    />
  );
}

export default function DetalhesDensidadeInSitu() {
  const { insituId } = useParams();
  const history = useHistory();
  const [form, setForm] = useState(estadoInicialDensidadeInSitu);
  const [formOriginal, setFormOriginal] = useState(estadoInicialDensidadeInSitu);
  const [compactacoes, setCompactacoes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [editando, setEditando] = useState(false);
  const [modoRelatorio, setModoRelatorio] = useState(false);
  const [confirmarCancelamento, setConfirmarCancelamento] = useState(false);
  const [erro, setErro] = useState("");
  const [larguraRolagem, setLarguraRolagem] = useState(980);
  const tabelasRef = useRef(null);
  const barraInferiorRef = useRef(null);

  useEffect(() => {
    carregarEnsaio();
  }, [insituId]);

  useEffect(() => {
    if (carregando || modoRelatorio) return undefined;

    function atualizarLarguraRolagem() {
      const tabelas = tabelasRef.current;
      const barra = barraInferiorRef.current;
      if (!tabelas || !barra) return;

      const diferencaLargura = Math.max(0, barra.clientWidth - tabelas.clientWidth);
      setLarguraRolagem(tabelas.scrollWidth + diferencaLargura);
    }

    const quadro = window.requestAnimationFrame(atualizarLarguraRolagem);
    window.addEventListener("resize", atualizarLarguraRolagem);
    return () => {
      window.cancelAnimationFrame(quadro);
      window.removeEventListener("resize", atualizarLarguraRolagem);
    };
  }, [carregando, modoRelatorio, form.ensaios?.length]);

  async function carregarEnsaio() {
    setCarregando(true);
    setErro("");

    try {
      const [snap, compactacoesSnap] = await Promise.all([
        getDoc(doc(db, COLLECTION_DENSIDADE_IN_SITU, insituId)),
        getDocs(consultaTenantAtual(query(collection(db, COLLECTION_COMPACTACAO), orderBy("criadoEm", "desc")))),
      ]);

      if (!snap.exists()) {
        setErro("Ensaio não encontrado.");
        setCarregando(false);
        return;
      }

      const dadosCarregados = recalcularDensidadeInSitu({ ...estadoInicialDensidadeInSitu, ...snap.data() });
      setForm(dadosCarregados);
      setFormOriginal(dadosCarregados);
      setEditando(false);
      setCompactacoes(compactacoesSnap.docs.map((item) => ({ id: item.id, ...item.data() })));
    } catch (error) {
      console.error(error);
      setErro("Não foi possível carregar o ensaio.");
    } finally {
      setCarregando(false);
    }
  }

  function atualizarFormulario(parcial, recalcular = false) {
    setEditando(true);
    setForm((atual) => {
      const proximo = { ...atual, ...parcial };
      return recalcular ? recalcularDensidadeInSitu(proximo) : proximo;
    });
  }

  function atualizarEnsaio(index, campo, valor) {
    setEditando(true);
    setForm((atual) => {
      const ensaios = [...(atual.ensaios || [])];
      const ensaioAtual = { ...ensaios[index], [campo]: valor };

      if ((campo === "conforme" || campo === "naoConforme") && !condicaoHabilitada(ensaioAtual)) {
        return atual;
      }

      if (campo === "conforme") {
        ensaioAtual.conforme = valor;
        if (valor) ensaioAtual.naoConforme = false;
      }

      if (campo === "naoConforme") {
        ensaioAtual.naoConforme = valor;
        if (valor) ensaioAtual.conforme = false;
      }

      const deveCalcular =
        !camposIdentificacaoSet.has(campo) &&
        campo !== "conforme" &&
        campo !== "naoConforme" &&
        (!camposSomenteCompactacao.has(campo) || ensaioAtual.compactacaoManual);

      const ensaioFinal = deveCalcular ? calcularEnsaioInSitu(ensaioAtual) : ensaioAtual;

      if (!condicaoHabilitada(ensaioFinal)) {
        ensaioFinal.conforme = false;
        ensaioFinal.naoConforme = false;
      }

      ensaios[index] = ensaioFinal;

      return { ...atual, ensaios };
    });
  }

  function acrescentarEnsaio() {
    setEditando(true);
    setForm((atual) => {
      const ensaiosAtuais = atual.ensaios || [];
      const novo = {
        ...criarEnsaiosInSitu(1)[0],
        id: ensaiosAtuais.length + 1,
        numero: String(ensaiosAtuais.length + 1),
        densidadeMaxima: ensaiosAtuais[0]?.densidadeMaxima || "",
        umidadeOtima: ensaiosAtuais[0]?.umidadeOtima || "",
        compactacaoId: ensaiosAtuais[0]?.compactacaoId || "",
        compactacaoCodigo: ensaiosAtuais[0]?.compactacaoCodigo || "",
        compactacaoManual: Boolean(ensaiosAtuais[0]?.compactacaoManual),
      };

      return { ...atual, ensaios: [...ensaiosAtuais, calcularEnsaioInSitu(novo)] };
    });
  }

  function selecionarCompactacaoEnsaio(index, compactacaoId) {
    setEditando(true);
    const manual = compactacaoId === COMPACTACAO_MANUAL_ID;
    const compactacao = compactacoes.find((item) => item.id === compactacaoId);
    const densidadeMaxima = compactacao?.resultados?.densidadeMaxima || "";
    const umidadeOtima = compactacao?.resultados?.umidadeOtima || "";

    setForm((atual) => {
      const ensaios = [...(atual.ensaios || [])];
      ensaios[index] = calcularEnsaioInSitu({
        ...ensaios[index],
        compactacaoManual: manual,
        compactacaoId: compactacao?.id || "",
        compactacaoCodigo: manual ? "Manual" : compactacao?.registroNumero || compactacao?.codigo || "",
        densidadeMaxima: manual ? ensaios[index]?.densidadeMaxima || "" : densidadeMaxima,
        umidadeOtima: manual ? ensaios[index]?.umidadeOtima || "" : umidadeOtima,
      });

      return { ...atual, ensaios };
    });
  }

  function compactacoesDaObra() {
    if (!form.obraId && !form.obra) return compactacoes;

    return compactacoes.filter((compactacao) => {
      if (form.obraId && compactacao.obraId) {
        return compactacao.obraId === form.obraId;
      }

      if (form.obra) {
        return String(compactacao.obra || "").trim().toLowerCase() === String(form.obra || "").trim().toLowerCase();
      }

      return true;
    });
  }

  async function salvar() {
    if (!editando) return;

    setSalvando(true);
    setErro("");

    try {
      const user = auth.currentUser;
      const usuarioAtual = await getUsuarioAtualComTenant();
      const usuarioRegistro = user
        ? {
            uid: user.uid,
            nome: user.displayName || user.email || "",
            email: user.email || "",
          }
        : null;

      const dadosParaSalvar = {
        ...recalcularDensidadeInSitu(form),
        atualizadoEm: new Date(),
        updatedBy: usuarioRegistro,
      };

      if (podeEditarCadastroDireto(usuarioAtual, formOriginal)) {
        const dadosMescladosSalvos = await atualizarDocumentoComMesclagem({
          db,
          referencia: doc(db, COLLECTION_DENSIDADE_IN_SITU, insituId),
          original: formOriginal,
          atual: form,
          preparar: recalcularDensidadeInSitu,
          metadados: {
            atualizadoEm: dadosParaSalvar.atualizadoEm,
            updatedBy: usuarioRegistro,
          },
        });
        setForm(dadosMescladosSalvos);
        setFormOriginal(dadosMescladosSalvos);
      } else {
        const camposEditados = extrairCamposAlterados(formOriginal, form);
        const alteracoesSolicitadas = Object.keys(camposEditados).reduce(
          (alteracoes, campo) => {
            alteracoes[campo] = dadosParaSalvar[campo];
            return alteracoes;
          },
          {
            atualizadoEm: dadosParaSalvar.atualizadoEm,
            updatedBy: usuarioRegistro,
          }
        );
        await solicitarAprovacaoCadastro({
          usuario: usuarioAtual,
          registro: formOriginal,
          colecao: COLLECTION_DENSIDADE_IN_SITU,
          registroId: insituId,
          dados: alteracoesSolicitadas,
          tipo: "densidade_in_situ",
          titulo: `Alteração de densidade in situ ${formOriginal.codigo || ""}`,
        });
        alert("Alteração enviada para aprovação do administrador.");
        setForm(formOriginal);
      }
      setEditando(false);
    } catch (error) {
      console.error(error);
      setErro("Não foi possível salvar o ensaio.");
    } finally {
      setSalvando(false);
    }
  }

  function cancelarAlteracoes() {
    setConfirmarCancelamento(true);
  }

  function confirmarCancelarAlteracoes() {
    setForm(formOriginal);
    setEditando(false);
    setErro("");
    setConfirmarCancelamento(false);
  }

  if (carregando) {
    return (
      <>
        <Navbar />
        <Box sx={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (modoRelatorio) {
    return (
      <RelatorioDensidadeInSituPrint
        dados={recalcularDensidadeInSitu(form)}
        onVoltar={() => setModoRelatorio(false)}
      />
    );
  }

  return (
    <>
      <Navbar />

      <CabecalhoDetalhes titulo="Densidade IN SITU" subtitulo="RQ 2.1.2   Rev.00 - 20/08/2025">
            <Button startIcon={<ArrowBackIcon />} onClick={() => history.push("/app/densidade-in-situ")} disabled={editando || salvando}>Voltar</Button>
            <Button
              startIcon={<PrintIcon />}
              variant="outlined"
              onClick={() => setModoRelatorio(true)}
              disabled={editando || salvando}
            >
              Relatório
            </Button>
            <Button startIcon={<SaveIcon />} variant="contained" onClick={salvar} disabled={!editando || salvando}>
              {salvando ? "Salvando..." : "Salvar"}
            </Button>
            <Button data-confirmacao-cancelamento="propria" variant="outlined" onClick={cancelarAlteracoes} disabled={!editando || salvando}>
              Cancelar alterações
            </Button>
      </CabecalhoDetalhes>

      <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1180, mx: "auto" }}>

        {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

        <Paper sx={{ p: 2, mb: 2, border: "1px solid #d7dde8", boxShadow: "none" }}>
          <Stack spacing={1.5}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
              <TextField label="Código" value={form.codigo || ""} onChange={(e) => atualizarFormulario({ codigo: e.target.value })} sx={{ ...campoCompactoSx, width: { xs: "100%", md: 150 } }} />
              <TextField label="Data" type="date" InputLabelProps={{ shrink: true }} value={form.dataEnsaio || ""} onChange={(e) => atualizarFormulario({ dataEnsaio: e.target.value })} sx={{ ...campoCompactoSx, width: { xs: "100%", md: 145 } }} />
              <TextField label="Empresa" value={form.empresa || form.cliente || ""} onChange={(e) => atualizarFormulario({ empresa: e.target.value, cliente: e.target.value })} sx={{ ...campoCompactoSx, flex: 1 }} />
              <TextField label="Obra" value={form.obra || ""} onChange={(e) => atualizarFormulario({ obra: e.target.value })} sx={{ ...campoCompactoSx, flex: 1 }} />
            </Stack>
            <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
              <TextField label="Camada/Estudo" value={form.camadaEstudo || ""} onChange={(e) => atualizarFormulario({ camadaEstudo: e.target.value })} sx={{ ...campoCompactoSx, flex: 1 }} />
              <TextField label="Operador" value={form.operador || ""} onChange={(e) => atualizarFormulario({ operador: e.target.value })} sx={{ ...campoCompactoSx, width: { xs: "100%", md: 180 } }} />
              <TextField label="Calculista" value={form.calculista || ""} onChange={(e) => atualizarFormulario({ calculista: e.target.value })} sx={{ ...campoCompactoSx, width: { xs: "100%", md: 180 } }} />
              <Button startIcon={<AddIcon />} variant="outlined" onClick={acrescentarEnsaio} sx={{ minWidth: 190, height: 38 }}>
                Acrescentar Ensaio
              </Button>

            </Stack>
          </Stack>
        </Paper>

        <Paper
          ref={tabelasRef}
          onScroll={(event) => {
            if (barraInferiorRef.current) {
              barraInferiorRef.current.scrollLeft = event.currentTarget.scrollLeft;
            }
          }}
          sx={{ overflowX: "auto", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" }, border: "1px solid #d7dde8", boxShadow: "none" }}
        >
          <Box sx={{ width: Math.max(980, 430 + (form.ensaios || []).length * 170) }}>
            <TabelaDensidade
              ensaios={form.ensaios || []}
              onChange={atualizarEnsaio}
            />

            <TabelaSecao
              titulo="Resultados de compactação"
              campos={camposCompactacao}
              ensaios={form.ensaios || []}
              compactacoes={compactacoesDaObra()}
              onChange={atualizarEnsaio}
              onSelecionarCompactacao={selecionarCompactacaoEnsaio}
            />
          </Box>
        </Paper>
        <Box
          ref={barraInferiorRef}
          onScroll={(event) => {
            if (tabelasRef.current) {
              tabelasRef.current.scrollLeft = event.currentTarget.scrollLeft;
            }
          }}
          aria-label="Rolagem horizontal dos ensaios de densidade in situ"
          sx={{ position: "fixed", bottom: 0, left: 0, width: "100vw", height: 20, overflowX: "auto", overflowY: "hidden", bgcolor: "background.paper", borderTop: "1px solid #94a3b8", zIndex: 1300 }}
        >
          <Box sx={{ width: larguraRolagem, height: 1 }} />
        </Box>

        <Paper sx={{ p: 2, mt: 2, border: "1px solid #d7dde8", boxShadow: "none" }}>
          <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={2}>
            <TextField
              key={`laboratorio-${formOriginal.laboratorio || ""}`}
              label="Laboratório"
              defaultValue={form.laboratorio || ""}
              onBlur={(e) => atualizarFormulario({ laboratorio: e.target.value })}
              fullWidth
            />
            <TextField
              key={`fiscalizacao-${formOriginal.fiscalizacao || ""}`}
              label="Fiscalização"
              defaultValue={form.fiscalizacao || ""}
              onBlur={(e) => atualizarFormulario({ fiscalizacao: e.target.value })}
              fullWidth
            />
          </Stack>
          <TextField
            key={`observacao-${formOriginal.observacao || ""}`}
            label="Observação"
            defaultValue={form.observacao || ""}
            onBlur={(e) => atualizarFormulario({ observacao: e.target.value })}
            multiline
            minRows={3}
            fullWidth
          />
        </Paper>
      </Box>

      <Dialog open={confirmarCancelamento} onClose={() => setConfirmarCancelamento(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Cancelar alterações?</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            Todas as alterações serão perdidas. Deseja continuar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmarCancelamento(false)}>Não</Button>
          <Button variant="contained" color="error" onClick={confirmarCancelarAlteracoes}>
            Sim, descartar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function TabelaDensidade({ ensaios, onChange }) {
  return (
      <Table size="small" sx={{ width: "100%", tableLayout: "fixed" }}>
        <TableHead sx={{ backgroundColor: "#f1f5f9" }}>
          <TableRow>
            <TableCell sx={{ ...cellSx, textAlign: "left", width: 260 }}><strong>Campo</strong></TableCell>
            <TableCell sx={{ ...cellSx, width: 170 }}><strong>Fórmula</strong></TableCell>
            {ensaios.map((ensaio, index) => (
              <TableCell key={index} sx={{ ...cellSx, width: 170 }} align="center">Ensaio {index + 1}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <LinhaTitulo titulo="Dados de identificação do furo" colSpan={ensaios.length + 2} />
          {camposIdentificacao.map(([campo, label, formula], rowIndex) => (
            <LinhaCampo key={campo} campo={campo} label={label} formula={formula} ensaios={ensaios} onChange={onChange} rowIndex={rowIndex} />
          ))}

          <LinhaTitulo titulo="Determinação da densidade" colSpan={ensaios.length + 2} />
          {camposDensidade.map(([campo, label, formula], rowIndex) => (
            <LinhaCampo key={campo} campo={campo} label={label} formula={formula} ensaios={ensaios} onChange={onChange} rowIndex={camposIdentificacao.length + rowIndex} />
          ))}
        </TableBody>
      </Table>
  );
}

function LinhaTitulo({ titulo, colSpan }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ ...cellSx, fontWeight: 700, textTransform: "uppercase", backgroundColor: "#f8fafc" }}>
        {titulo}
      </TableCell>
    </TableRow>
  );
}

function LinhaCampo({ campo, label, formula, ensaios, onChange, rowIndex }) {
  return (
    <TableRow>
      <TableCell sx={{ ...cellSx, textAlign: "left", fontWeight: 700 }}>{label}</TableCell>
      <TableCell sx={cellSx}>{formula || "-"}</TableCell>
      {ensaios.map((ensaio, index) => (
        <TableCell key={`${campo}-${index}`} sx={cellSx}>
          {campoTabela(
            ensaio[campo],
            (valor) => onChange(index, campo, valor),
            camposCalculados.has(campo) || camposSomenteCompactacao.has(campo),
            { row: rowIndex, col: index }
          )}
        </TableCell>
      ))}
    </TableRow>
  );
}

function TabelaSecao({
  titulo,
  campos,
  ensaios,
  compactacoes = [],
  onChange,
  onSelecionarCompactacao
}) {
  const mostraSeletorCompactacao = titulo === "Resultados de compactação";
  const opcaoManualCompactacao = { id: COMPACTACAO_MANUAL_ID, registroNumero: "Manual", manual: true };
  const opcoesCompactacao = [opcaoManualCompactacao, ...compactacoes];
  const rotuloCompactacao = (compactacao) =>
    compactacao
      ? String(compactacao.registroNumero || compactacao.codigo || compactacao.id || "")
      : "";

  return (
      <Table size="small" sx={{ width: "100%", tableLayout: "fixed" }}>
        <TableHead sx={{ backgroundColor: "#f1f5f9" }}>
          <TableRow>
            <TableCell sx={{ ...cellSx, textAlign: "left", width: 260 }}><strong>{titulo}</strong></TableCell>
            <TableCell sx={{ ...cellSx, width: 170 }}><strong>Fórmula</strong></TableCell>
            {ensaios.map((ensaio, index) => (
              <TableCell key={index} sx={{ ...cellSx, width: 170 }} align="center">
                <Stack spacing={0.75}>
                  <Typography variant="caption" fontWeight={700}>Ensaio {index + 1}</Typography>
                  {mostraSeletorCompactacao && (
                    <Autocomplete
                      size="small"
                      options={opcoesCompactacao}
                      value={
                        ensaio.compactacaoManual
                          ? opcaoManualCompactacao
                          : compactacoes.find((compactacao) => compactacao.id === ensaio.compactacaoId) || null
                      }
                      getOptionLabel={rotuloCompactacao}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      filterOptions={(options, state) => {
                        const termo = String(state.inputValue || "").trim().toLowerCase();
                        if (!termo) return options;

                        return options.filter((compactacao) =>
                          [
                            compactacao.registroNumero,
                            compactacao.codigo,
                          ].some((campo) => contemTextoPesquisa(String(campo || "").toLowerCase(), termo))
                        );
                      }}
                      onChange={(event, compactacao) => onSelecionarCompactacao?.(index, compactacao?.id || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Registro"
                          variant="outlined"
                        />
                      )}
                      sx={{
                        minWidth: 155,
                        "& .MuiInputBase-root": {
                          minHeight: 30,
                          backgroundColor: "#fff",
                          fontSize: 11,
                        },
                        "& .MuiAutocomplete-input": {
                          fontSize: 11,
                          p: "2px !important",
                        },
                      }}
                    />
                  )}
                </Stack>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {campos.map(([campo, label, formula], rowIndex) => (
            <TableRow key={campo}>
              <TableCell sx={{ ...cellSx, textAlign: "left", fontWeight: 700 }}>{label}</TableCell>
              <TableCell sx={cellSx}>{formula || "-"}</TableCell>
              {ensaios.map((ensaio, index) => (
                <TableCell key={`${campo}-${index}`} sx={cellSx}>
                  {campoTabela(
                    ensaio[campo],
                    (valor) => onChange(index, campo, valor),
                    camposCalculados.has(campo) ||
                      (camposSomenteCompactacao.has(campo) && !ensaio.compactacaoManual),
                    { row: 1000 + rowIndex, col: index }
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
          {titulo === "Resultados de compactação" && (
            <TableRow>
              <TableCell sx={{ ...cellSx, textAlign: "left", fontWeight: 700 }}>Condição</TableCell>
              <TableCell sx={cellSx}>Seleção manual</TableCell>
              {ensaios.map((ensaio, index) => (
                <TableCell key={`condicao-${index}`} sx={cellSx}>
                  <Stack spacing={0.5} alignItems="flex-start">
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <input
                        type="checkbox"
                        checked={Boolean(ensaio.conforme)}
                        disabled={!condicaoHabilitada(ensaio)}
                        onChange={(e) => onChange(index, "conforme", e.target.checked)}
                      />
                      <Typography variant="caption">CONFORME</Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <input
                        type="checkbox"
                        checked={Boolean(ensaio.naoConforme)}
                        disabled={!condicaoHabilitada(ensaio)}
                        onChange={(e) => onChange(index, "naoConforme", e.target.checked)}
                      />
                      <Typography variant="caption">NÃO CONF.</Typography>
                    </Stack>
                  </Stack>
                </TableCell>
              ))}
            </TableRow>
          )}
        </TableBody>
      </Table>
  );
}



